import React from 'react';
import { Button } from 'antd';
import styles from './ToggleExpandBtn.module.scss';

const ToggleExpandBtn = ({ onClick, text }) => {
  return (
    <Button
      type="link"
      className={styles.root}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default ToggleExpandBtn;
